import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import * as track from '../../data/track/track';
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import green from '@material-ui/core/colors/green';
// core components
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";
import CardHeader from "src/components/Card/CardHeader.jsx";
import CardText from "src/components/Card/CardText.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";
import CardFooter from "src/components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import customSelectStyle from "src/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import ImageUpload from "src/components/CustomUpload/ImageUpload.jsx";
import * as model from '../../data/model';

import * as types from '../../types'

import { SSL_OP_NETSCAPE_CA_DN_BUG } from "constants";
import * as firebase from 'firebase/app';
import { string } from "prop-types";
import { PodCast } from "functions/lib/data/model";
import { ViewState, AppSection } from "../../types";
const styles = {
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    ...customSelectStyle,
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    registerButton: {
        float: "right"
    },
    deleteButton: {
        float: "left"
    }
};
let categories = model.PodCastCatgory.getCategories();
;
interface PodCastFormProps {
    classes: any;
    podcast: model.PodCast;
    connect: types.IState
}
interface PodCastFormState {
    podcast: model.PodCast;
    saving: boolean;
    errors: Array<types.ValidationError>;
    fieldCheck: any;
}
let valHelper = new types.ValidationHelper();
valHelper.fields = [
    {
        field: 'title',
        rules: [new types.RequiredRule()]
    }

];



class PodCastEdit extends React.Component<PodCastFormProps, PodCastFormState> {
    constructor(props: PodCastFormProps) {
        super(props);
        let podcast = new model.PodCast();

        if (this.props['match'].params.id != 'new') {


            podcast = this.props.connect.lo_PodCasts.val().find(x => x.id == this.props['match'].params.id)

        }
        this.state = {
            podcast: podcast,
            saving: false,
            errors: new Array<types.ValidationError>(),
            fieldCheck: {}
        };

    }
    /*
  export class PodCast extends BaseItem<PodCast> {
      title: string;
      sub_title: string;
      descrition: string;
      url: string;
      image_url: string;
      author: string;
      categories: Array<any>;
      private: boolean;
  }
  
    */
    uploadFile(path: any, file: any, base64: boolean): Promise<string> {
        var me = this;
        return new Promise<string>(async (resolve, reject) => {
            try {
                var storageRef = firebase.storage().ref();
                var spaceRef = storageRef.child("images/" + path);

                //me.showProgess("uploading file", 0,path);
                let uploadTask; //
                if (base64) {
                    uploadTask = spaceRef.putString(file, "base64");
                } else {
                    uploadTask = spaceRef.put(file);
                }
                // var uploadTask = storageRef.child("images/rivers.jpg").put(file);

                // Register three observers:
                // 1. 'state_changed' observer, called any time the state changes
                // 2. Error observer, called on failure
                // 3. Completion observer, called on successful completion
                uploadTask.on(
                    "state_changed",
                    function (snapshot) {
                        // Observe state change events such as progress, pause, and resume
                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

                        var progress =
                            snapshot.bytesTransferred / snapshot.totalBytes * 100;
                        console.log("Upload is " + progress + "% done");
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                // me.showProgess("uploading file - Paused", progress,path);
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log("Upload is running");
                                //me.showProgess("uploading file", progress,path);
                                break;
                        }
                    },
                    function (error) {
                        // me.closeProgess(path);
                        // $(`.image-progress-status[image-id="${path}"]`).text(error)
                        reject(error);
                        // Handle unsuccessful uploads
                    },
                    async function () {
                        // me.closeProgess(path);
                        // Handle successful uploads on complete
                        // For instance, get the download URL: https://firebasestorage.googleapis.com/...

                        let url = await uploadTask.snapshot.ref.getDownloadURL();//uploadTask.snapshot.downloadURL;

                        resolve(url);
                        // var downloadURL = uploadTask.snapshot.downloadURL;
                    }
                );
            } catch (e) {
                //this.closeProgess(path);
                //$(`.image-progress-status[image-id="${path}"]`).text("Error")
                reject(e);
            }
        });
    }
    componentWillReceiveProps(props: PodCastFormProps) {
        /*if(this.props['match'].params.id != this.state.podcast.id)
        {
               if(this.props['match'].params.id  == 'new')
               {
                   let s= {...this.state}
                   s.podcast = new model.PodCast();
                   this.setState(s);
               }
               else{
                   let s= {...this.state}
                   s.podcast = this.props.connect.lo_PodCasts.val().find(x=>x.id == this.props['match'].params.id )
                   this.setState(s);
               }
        }*/
    }
    async archiveClick(e) {
        if (prompt('Are you sure you want to delete this podcast?  If so type "YES" in allcaps') == "YES") {
            let s = { ...this.state };
            s.saving = true;
            this.setState(s);
        
           await this.props.connect.lo_ctx.val().PodCast.archive(this.state.podcast.id);//(this.state.podcast)
            track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.deletePodCast);
            ViewState.navigate(ViewState.getDefaultHash(AppSection.PodCast))
        }
    }
    async createClick(e) {
        try {
            let s = { ...this.state };
          
            s.saving = true;
            this.setState(s);
            let pc = this.state.podcast;

            let file = this.refs['image-upload']['state'].file;
            if (file) {
                pc.image_url = await this.uploadFile("/images/" + this.props.connect.lo_ctx.val().generateNewId(), file, false);

            }
            if(!pc.image_url)
            {
                pc.image_url = "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media";
    
            }
           
            pc.last_error =null;
            pc.feed_status = model.PodCastFeedStatus.dirty;
            let isNew = pc.is_new
            await this.props.connect.lo_ctx.val().PodCast.save(pc)
            if(isNew)
            { 
                track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.createPodCast);
            }
            else
            {
                track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.editPodCast);
            }
            ViewState.navigate(ViewState.getDefaultHash(AppSection.PodCast))
        }
        catch (e) {
            let s = { ...this.state };
            s.saving = false;
          //  s.errors = [{ field: null, message: 'Unable to archive podcast. ' + e }]
         
            track.Track.reportError(e,'Unable to save podcast',true,this.props.connect.dispatch);
                   
                      
            this.setState(s);
        }
    }
    change(field: string, value: any) {
        let s = { ...this.state };
        s.podcast[field] = value;
        s.fieldCheck[field] = true;
        let errors: Array<types.ValidationError> = s.errors ? new Array<types.ValidationError>() : s.errors;
        errors = errors.filter(x => x.field != field);
        let vr = valHelper.validateField(this.state.podcast, field, value)
        if (vr) {
            errors = errors.concat(vr.errors)
        }
        s.errors = errors;
        this.setState(s);

    }
    render() {
        const { classes } = this.props;
        let me = this;
        let previewImage = this.state.podcast.image_url;
        if (!previewImage) {
            previewImage = this.props.connect.lo_ctx.val().getProfile().profile_url;
        }
        let selectedCategories = new Array<any>();
        for (var i in this.state.podcast.categories) {
            selectedCategories.push(i);
        }
        let saveEnabled = valHelper.validateForm(this.state.podcast).errors.length == 0 && !this.state.saving

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <MailOutline />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {this.state.podcast.is_new &&
                                    <span>Create PodCast</span>
                                }
                                {!this.state.podcast.is_new &&
                                    <span>Edit PodCast</span>
                                }

                            </h4>
                        </CardHeader>
                        <CardBody>
                            <form>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <CustomInput

                                            labelText="Title *"
                                            id="title"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            helpText={valHelper.getFirstError('title', this.state.errors)}
                                            success={this.state.fieldCheck['title'] && !valHelper.getFirstError('title', this.state.errors)}
                                            error={valHelper.getFirstError('title', this.state.errors)}
                                            inputProps={{
                                                value: this.state.podcast.title,
                                                onChange: (e) => {
                                                    me.change('title', e.target.value)
                                                    /*  let s = {...me.state}
                                                      s.podcast.title = e.target.value;
                                                      me.setState(s);*/
                                                }
                                            }}
                                        />
                                        <CustomInput

                                            labelText="Author"
                                            id="author"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            helpText={valHelper.getFirstError('author', this.state.errors)}
                                            success={this.state.fieldCheck['author'] && !valHelper.getFirstError('author', this.state.errors)}
                                            error={valHelper.getFirstError('author', this.state.errors)}

                                            inputProps={{
                                                value: this.state.podcast.author,
                                                onChange: (e) => {
                                                    me.change('author', e.target.value)
                                                }
                                            }}

                                        />
                                        <FormControl
                                            fullWidth
                                        >
                                            <InputLabel
                                                htmlFor="multiple-select"
                                                className={classes.selectLabel}
                                            >
                                                Choose Category
</InputLabel>
                                            <Select
                                                multiple
                                                value={selectedCategories}
                                                error={valHelper.getFirstError('categories', this.state.errors) != null}

                                                onChange={(e: any) => {
                                                   
                                                    let s = { ...me.state }
                                                    if (e.target.value.length > 4) {
                                                        alert("You can only select up to 3 categories.")
                                                    }
                                                    else {
                                                        let keys = e.target.value as Array<any>;
                                                        let cat = {};
                                                        keys.forEach(key => {

                                                            cat[key]= true;
                                                        });
                                                        console.log(JSON.stringify(cat))
                                                        me.change('categories', cat)


                                                    }
                                                }}
                                                MenuProps={{ className: classes.selectMenu }}
                                                classes={{ select: classes.select }}
                                                inputProps={{
                                                    name: "multipleSelect",
                                                    id: "multiple-select"
                                                }}
                                                renderValue={(e: Array<any>) => {
                                                    if (!e) {
                                                        e = new Array<any>();
                                                    }

                                                    let selectedString = categories.filter(x => {
                                                        return e.includes(x.id)
                                                    }).map(x => x.display_name).join(',')

                                                    return (
                                                        <span>{selectedString}</span>
                                                    )
                                                }}
                                            >
                                                <MenuItem
                                                    disabled
                                                    classes={{
                                                        root: classes.selectMenuItem
                                                    }}
                                                >
                                                    Choose Categories
</MenuItem>

                                                {categories.map((category: model.PodCastCatgory) => (
                                                    <MenuItem
                                                        key={category.id}
                                                        classes={{
                                                            root: classes.selectMenuItem,
                                                            selected: classes.selectMenuItemSelectedMultiple
                                                        }}
                                                        value={category.id}
                                                    >
                                                        {category.parent_category_id && (
                                                            <span> {"\u00a0\u00a0" + category.display_name}</span>
                                                        )
                                                        }
                                                        {!category.parent_category_id && (
                                                            <strong>{category.display_name}</strong>
                                                        )

                                                        }

                                                    </MenuItem>
                                                ))}



                                            </Select>
                                        </FormControl>


                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>

                                        <ImageUpload
                                            ref='image-upload'
                                            defaultImage={previewImage}
                                            addButtonProps={{

                                                round: true
                                            }}
                                            changeButtonProps={{

                                                round: true
                                            }}
                                            removeButtonProps={{
                                                color: "danger",
                                                round: true
                                            }}
                                        />

                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={10}>
                                        <FormControl
                                            fullWidth
                                        >
                                            <CustomInput
                                                id="filled-multiline-static"
                                                labelText="Description"
                                                helpText={valHelper.getFirstError('descrition', this.state.errors)}
                                                success={this.state.fieldCheck['descrition'] && !valHelper.getFirstError('descrition', this.state.errors)}
                                                error={valHelper.getFirstError('descrition', this.state.errors)}

                                                inputProps={{
                                                    multiline: true,
                                                    fullWidth: true,
                                                    value: this.state.podcast.descrition,

                                                    onChange: (e) => {
                                                        me.change('descrition', e.target.value);
                                                    }
                                                }}

                                                className={classes.textField}
                                                margin="normal"

                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>

                                <Button


                                    variant="contained"

                                    onClick={this.archiveClick.bind(this)}
                                    disabled={this.state.saving}

                                    className={classes.deleteButton}
                                >
                                    Archive PodCast
                </Button>
                                <Button
                                    color="primary"
                                    onClick={this.createClick.bind(this)}
                                    variant="contained"


                                    disabled={!saveEnabled}

                                    className={classes.registerButton}
                                >
                                    {this.state.saving && (
                                        <span>Saving</span>
                                    )
                                    }

                                    {!this.state.saving && (
                                        <span>
                                            {this.state.podcast.is_new &&
                                                <span>Create PodCast</span>
                                            }
                                            {!this.state.podcast.is_new &&
                                                <span>Update PodCast</span>
                                            }
                                        </span>
                                    )
                                    }
                                </Button>
                            </form>
                        </CardBody>

                    </Card>
                </GridItem>
            </GridContainer >
        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(PodCastEdit));




// WEBPACK FOOTER //
// ./src/views/podcast/PodCastEdit.tsx